export function textAreaConfig() {
    return {
        maxHeight: "none"
    };
}
